module.exports = __webpack_public_path__ + "assets/img/img_ai_shanghai.e8f1fa76.jpg";